import { API_BASE_URL } from '../../apiClient';

const API_URL = API_BASE_URL;
export default API_URL;
